(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.hide_tags = {
    attach: function(context, settings) {
      const divs = document.getElementsByClassName('views-field-type');

      for (let x = 0; x < divs.length; x++) {
        const div = divs[x];
        const content = div.textContent.trim();

        if (content === 'Basic page'
        || content === 'Overview Page'
        || content === 'List View Page'
        || content === 'Homepage'
        || content === 'Private File Store'
        || content === 'Staff') {
          div.style.display = 'none';
        }
      }

      $('.views-field-field-market-segment a, .views-field-field-sector a').once('rewrite-term-url').each(function() {
        // Get the href attribute of the current <a> tag
        var href = $(this).attr('href');

        // Split the href to get the last segment
        var segments = href.split('/');
        var lastSegment = segments.pop();

        // Get the current URL
        var currentUrl = window.location.href;

        // Split the URL into base and parameters
        var urlParts = currentUrl.split('?');
        var baseUrl = urlParts[0];
        var params = urlParts[1];

        // If there are parameters
        if (params) {
          // Split the parameters into key-value pairs
          var paramPairs = params.split('&');
          var newParams = [];

          // Iterate through each key-value pair
          $.each(paramPairs, function(index, pair) {
            // Split the pair into key and value
            var keyValue = pair.split('=');
            var key = keyValue[0];
            var value = keyValue[1];

            // Check if the key is 'market-segment'
            if (key === 'market-segment') {
              // Set the value to the last segment of the href
              value = lastSegment;
            }

            // Reconstruct the parameter pair and add it to the new parameters array
            newParams.push(key + '=' + value);
          });

          // Construct the new URL with updated parameters
          var newUrl = baseUrl + '?' + newParams.join('&');

          // if the last segment is in the current url add active the href
          if (currentUrl.includes(lastSegment)) {
            $(this).addClass('active');
          }

          // Output the new URL (you can replace this with your desired action)
          $(this).attr('href', newUrl);
        }
      });
    }
  };
})(jQuery, Drupal, once);
